import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";

import image_1 from "../../assets/images/1.webp";
import image_2 from "../../assets/images/2.webp";
import image_3 from "../../assets/images/3.webp";
import image_4 from "../../assets/images/4.webp";
import image_5 from "../../assets/images/5.webp";
import { useSwipeable } from "react-swipeable";

const images = [image_1, image_2, image_3, image_4, image_5];

export const ImageCarousel = ({
  height,
  width
}) => {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const [isPaused, setIsPaused] = useState(false);
  const carouselRef = useRef(null);

  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      nextSlide(1);
    }, 6000);
    return () => clearInterval(interval);
  }, [isPaused]);

  const nextSlide = (dir) => {
    setDirection(dir);
    setIndex((prevIndex) => (prevIndex + dir + images.length) % images.length);
  };

  const goToSlide = (i) => {
    setDirection(i > index ? 1 : -1);
    setIndex(i);
  };
  const handlers = useSwipeable({
    onSwipedLeft: () => nextSlide(1),
    onSwipedRight: () => nextSlide(-1),
    preventScrollOnSwipe: true,
    trackTouch: true,
    trackMouse: false,
  });

  return (
    <div
      {...handlers}
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
      onFocus={() => setIsPaused(true)}
      onBlur={() => setIsPaused(false)}
      className={`items-center justify-center ${width ? width : "w-full"} ${height.toString()} hidden 
      lg:flex rounded-2xl`}
    >
      <div
        ref={carouselRef}
        className="w-full h-full flex relative overflow-hidden rounded-2xl"
      >
        <AnimatePresence>
          <motion.div
            key={images[index]}
            className="absolute w-full h-full "
            initial={{ opacity: 0, x: direction === 1 ? 50 : -50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: direction === 1 ? -50 : 50 }}
            transition={{ duration: 0.5 }}
          >
            <motion.img
              src={images[index]}
              alt="carousel slide"
              className="w-full h-full object-cover rounded-2xl"
            />
          </motion.div>
        </AnimatePresence>

        <div
          className="absolute bottom-4 left-1/2 transform -translate-x-1/2 
        flex gap-2 w-full px-2 items-center justify-center"
        >
          {images.map((_, i) => (
            <button
              key={i}
              onClick={() => goToSlide(i)}
              className={` h-2 w-48 rounded-full transition-all ${
                i === index ? "bg-gray-200 " : "bg-white "
              }`}
            ></button>
          ))}
        </div>
      </div>
    </div>
  );
};
export default ImageCarousel;
